import type { PanelOrganizationListQuery } from '@icebreaker/shared';
import type { OrganizationFilters } from '../store/organizations.slice';

export const ORGANIZATION_PAGE_SIZE = 20;

/** Ekran süzgeci → sunucu sorgusu. Boş arama sorguya GİRMEZ. */
export function toOrganizationQuery(filters: OrganizationFilters): PanelOrganizationListQuery {
  const q = filters.q.trim();
  return { ...(q ? { q } : {}), page: filters.page, pageSize: ORGANIZATION_PAGE_SIZE };
}
